
  /* PostHog capture — safe no-op when analytics is disabled. Shared by every
     hook below so a missing/blocked PostHog never breaks the PDP. */
  function jcTrack(name, props) { try { if (window.posthog && posthog.capture) posthog.capture(name, props || {}); } catch (e) {} }

  // gallery
  var gMain = document.getElementById('gMain');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function(t){
    t.addEventListener('click', function(){
      thumbs.forEach(function(x){ x.classList.remove('sel'); });
      t.classList.add('sel');
      t.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      gMain.src = t.dataset.full;
      gMain.style.objectFit = t.classList.contains('contain') ? 'contain' : 'cover';
      gMain.style.width = t.classList.contains('contain') ? '82%' : '100%';
      gMain.style.height = t.classList.contains('contain') ? '82%' : '100%';
    });
  });

  /* gallery arrows: reuse the thumb click so the selected thumb, image fit and
     any future gallery state stay in one place rather than diverging. */
  (function () {
    var prev = document.getElementById('gPrev');
    var next = document.getElementById('gNext');
    if (!prev || !next || !thumbs.length) return;
    function step(dir) {
      var list = [].slice.call(thumbs);
      var i = list.findIndex(function (t) { return t.classList.contains('sel'); });
      if (i < 0) i = 0;
      var n = (i + dir + list.length) % list.length;   // wraps both ways
      list[n].click();
    }
    prev.addEventListener('click', function (e) { e.preventDefault(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); step(1); });
  })();

  /* thumbnail scroll hint: right-edge arrow that scrolls the strip and hides at the end */
  (function () {
    var wrap = document.querySelector('.thumbs-wrap');
    var strip = document.querySelector('.thumbs');
    var hint = document.getElementById('thumbsHint');
    if (!wrap || !strip) return;
    function update() {
      var scrollable = strip.scrollWidth - strip.clientWidth;
      wrap.classList.toggle('no-scroll', scrollable <= 2);
      wrap.classList.toggle('at-end', strip.scrollLeft >= scrollable - 2);
    }
    strip.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (hint) hint.addEventListener('click', function () { strip.scrollBy({ left: strip.clientWidth * 0.7, behavior: 'smooth' }); });
    update();
  })();


  // weight chips
  var chips = document.querySelectorAll('#weights .chip');
  chips.forEach(function(c){
    c.addEventListener('click', function(){
      chips.forEach(function(x){ x.classList.remove('sel'); });
      c.classList.add('sel');
    });
  });

  // plan selection -> CTA + value stack + sticky bar

  // sticky ATC after scrolling past the buy box
  var bar = document.getElementById('stickybar');
  var hero = document.getElementById('buy');
  if ('IntersectionObserver' in window && bar && hero) {
    var stickySeen = false;
    new IntersectionObserver(function(entries){
      var e = entries[0];
      var showBar = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('show', showBar);
      if (showBar && !stickySeen) { stickySeen = true; jcTrack('sticky_cta_view', {}); }
    }, {threshold: 0}).observe(hero);
  }



/* ---- Paket-Popup (PetLab-style bottom sheet) -------------------------------
   Pure UI here: open/close, selection state, and the price figures it is told
   to show. It owns NO pricing logic — jc-pdp.js (Shopify/Recharge) drives the
   numbers, so the sheet can never disagree with checkout.
--------------------------------------------------------------------------- */
(function () {
  var sheet = document.getElementById("plSheet");
  var back  = document.getElementById("plBackdrop");
  var open  = document.getElementById("plOpen");
  if (!sheet || !back || !open) return;

  // Scroll lock. `body { overflow: hidden }` alone is not enough — iOS Safari
  // ignores it and keeps scrolling the page behind the sheet. Pinning the body with
  // position:fixed at its current offset is the only reliable way; we restore the
  // exact scroll position on close so the page does not jump.
  var lockedAt = 0;
  function lockScroll() {
    lockedAt = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.classList.add("pl-lock");
    b.style.position = "fixed";
    b.style.top = -lockedAt + "px";
    b.style.left = "0";
    b.style.right = "0";
    b.style.width = "100%";
  }
  function unlockScroll() {
    var b = document.body;
    b.classList.remove("pl-lock");
    b.style.position = "";
    b.style.top = "";
    b.style.left = "";
    b.style.right = "";
    b.style.width = "";
    window.scrollTo(0, lockedAt);
  }

  function show() {
    sheet.hidden = false; back.hidden = false;
    lockScroll();
    requestAnimationFrame(function () {
      sheet.classList.add("open"); back.classList.add("open");
    });
  }
  function abandonIfOpen() {
    // Opened the buy sheet but left without adding to cart — a hesitation signal.
    // _plAdded is set by the add-to-cart handler; a successful add navigates away
    // and never counts as an abandon.
    if (sheet._plOpened && !sheet._plAdded) {
      jcTrack("sheet_abandon", {
        sheet_config: sheet.dataset.config || null,
        plan_switch_count: sheet._plSwitches || 0,
        dwell_ms: sheet._plOpenedAt ? Date.now() - sheet._plOpenedAt : null
      });
    }
    sheet._plOpened = false;
  }
  function hide() {
    abandonIfOpen();
    sheet.classList.remove("open"); back.classList.remove("open");
    unlockScroll();
    setTimeout(function () { sheet.hidden = true; back.hidden = true; }, 300);
  }
  window.addEventListener("pagehide", abandonIfOpen);
  // the backdrop must not scroll anything at all
  back.addEventListener("touchmove", function (e) { e.preventDefault(); }, { passive: false });
  back.addEventListener("click", hide);
  var handle = document.getElementById("plHandle");
  if (handle) handle.addEventListener("click", hide);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !sheet.hidden) hide();
  });
  sheet.plHide = hide;

  function pick(list, el) {
    list.forEach(function (x) {
      x.classList.remove("sel");
      // Only elements wired as ARIA radios below carry these; setting them on
      // plain buttons (.pl-size / .pl-tog) would be wrong, so gate on role.
      if (x.getAttribute("role") === "radio") {
        x.setAttribute("aria-checked", "false");
        x.tabIndex = -1;
      }
    });
    el.classList.add("sel");
    if (el.getAttribute("role") === "radio") {
      el.setAttribute("aria-checked", "true");
      el.tabIndex = 0;
    }
  }
  var sizes = [].slice.call(sheet.querySelectorAll(".pl-size"));
  var togs  = [].slice.call(sheet.querySelectorAll(".pl-tog"));
  var plans = [].slice.call(sheet.querySelectorAll(".pl-plan"));

  // The plan cards are <label>s with no control inside, so nothing focused them
  // and 1 Dose / 3 Dosen was unreachable by keyboard — the sheet could be opened
  // but the package never changed. Promote them to a proper radiogroup with a
  // roving tabindex rather than adding real inputs, which would double-fire the
  // click handler below (label click -> synthetic input click).
  (function () {
    var group = document.getElementById("plPlans");
    if (!group || !plans.length) return;
    group.setAttribute("role", "radiogroup");
    if (!group.getAttribute("aria-label")) group.setAttribute("aria-label", "Paket wählen");
    plans.forEach(function (p) {
      p.setAttribute("role", "radio");
      var on = p.classList.contains("sel");
      p.setAttribute("aria-checked", on ? "true" : "false");
      p.tabIndex = on ? 0 : -1;
      p.addEventListener("keydown", function (e) {
        var k = e.key;
        if (k === " " || k === "Enter") { e.preventDefault(); p.click(); return; }
        var fwd = k === "ArrowDown" || k === "ArrowRight";
        var back = k === "ArrowUp" || k === "ArrowLeft";
        if (!fwd && !back) return;
        e.preventDefault();
        var i = plans.indexOf(p);
        var next = plans[(i + (fwd ? 1 : plans.length - 1)) % plans.length];
        next.focus();
        next.click();   // radiogroups select on arrow, matching native radios
      });
    });
  })();

  function emit() { sheet.dispatchEvent(new CustomEvent("pl:change")); }

  sizes.forEach(function (b) {
    b.addEventListener("click", function () {
      pick(sizes, b); emit();
      jcTrack("weight_selected", { weight: b.getAttribute("data-key") || (b.textContent || "").trim(), sheet_config: sheet.dataset.config || null });
    });
  });
  togs.forEach(function (b) {
    b.addEventListener("click", function () {
      pick(togs, b);
      sheet.setAttribute("data-mode", b.getAttribute("data-mode"));
      emit();
      sheet._plSwitches = (sheet._plSwitches || 0) + 1;
      jcTrack("mode_toggle", { to: b.getAttribute("data-mode"), sheet_config: sheet.dataset.config || null });
    });
  });
  plans.forEach(function (p) {
    p.addEventListener("click", function () {
      pick(plans, p); emit();
      sheet._plSwitches = (sheet._plSwitches || 0) + 1;
      jcTrack("plan_selected", { plan: p.getAttribute("data-plan") === "q3" ? 3 : 1, mode: sheet.getAttribute("data-mode"), sheet_config: sheet.dataset.config || null });
    });
  });
  sheet.setAttribute("data-mode", "sub");

  /* One sheet, opened in different configs (the A/B/C variants reuse it):
       'full'    → both modes, subscription pre-selected (control).
       'sub'     → subscription only; the mode toggle is hidden (variant B main CTA).
       'onetime' → both modes, one-time pre-selected (variant B "Einmaliger Kauf" link).
       'otponly' → one-time only; toggle hidden, no Abo cross-sell (variant C).
     'onetime' and 'otponly' both land in one-time mode; they differ in whether the
     customer can still switch to Abo, so keep them distinct — collapsing them would
     put the subscription toggle back on variant C.
     Config is read from the opener's data-sheet attribute so no opener needs to
     know the sheet internals. emit() makes the pricing engine recompute for the mode. */
  function applyConfig(config) {
    var mode = (config === "onetime" || config === "otponly") ? "onetime" : "sub";
    sheet.classList.toggle("sub-only", config === "sub");
    sheet.classList.toggle("otp-only", config === "otponly");
    sheet.setAttribute("data-mode", mode);
    sheet.dataset.config = config;
    togs.forEach(function (t) { t.classList.toggle("sel", t.getAttribute("data-mode") === mode); });
    emit();
  }
  function openWith(config, opener) {
    applyConfig(config || "full");
    sheet._plOpened = true; sheet._plAdded = false; sheet._plSwitches = 0; sheet._plOpenedAt = Date.now();
    jcTrack("sheet_open", { opener: opener || "unknown", sheet_config: config || "full" });
    show();
  }

  open.addEventListener("click", function () { openWith(open.getAttribute("data-sheet") || "full", "main_cta"); });

  var otp = document.getElementById("plOtp");
  if (otp) otp.addEventListener("click", function (e) {
    e.preventDefault();
    openWith("onetime", "otp_link");
    jcTrack("otp_link_click", { sheet_config: "onetime" });
  });

  // also open the sheet from the sticky bar CTA, in the page's configured mode
  var sticky = document.querySelector(".sticky .btn, .sticky button");
  if (sticky) sticky.addEventListener("click", function (e) { e.preventDefault(); openWith(sticky.getAttribute("data-sheet") || "full", "sticky"); });

  // Secondary CTAs (the <a href="#buy"> links scattered down the page) used to
  // only scroll to the buy box. They should scroll up AND then open the sheet,
  // in the page's configured mode. The main CTA (#plOpen), OTP link and sticky
  // bar are wired above; the sticky bar is fixed so it never scrolls — skip it.
  var buyBox = document.getElementById("buy");
  function scrollThenOpen(cfg, opener) {
    var opened = false;
    function fire() {
      if (opened) return; opened = true;
      window.removeEventListener("scrollend", fire);
      clearTimeout(fallback);
      openWith(cfg, opener);
    }
    var targetY = buyBox ? (window.pageYOffset + buyBox.getBoundingClientRect().top) : 0;
    // Already at the buy box: open immediately, nothing to scroll.
    if (Math.abs(targetY - window.pageYOffset) <= 4) { openWith(cfg, opener); return; }
    // Otherwise open once the smooth scroll settles (scrollend), with a timeout
    // fallback for browsers without scrollend support.
    window.addEventListener("scrollend", fire);
    var fallback = setTimeout(fire, 1000);
    if (buyBox) buyBox.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.scrollTo({ top: 0, behavior: "smooth" });
  }
  [].slice.call(document.querySelectorAll('a[href="#buy"]')).forEach(function (a) {
    if (a.closest(".sticky")) return; // sticky bar has its own opener above
    a.addEventListener("click", function (e) {
      e.preventDefault();
      scrollThenOpen(a.getAttribute("data-sheet") || open.getAttribute("data-sheet") || "full", "secondary_cta");
    });
  });
})();


/* ---- Shopify + Recharge engine for the Paket-Popup -------------------------
   Selection lives in the sheet (PetLab-style picker); ALL money comes from the
   live variant + Recharge selling-plan allocation, so the sheet can never show
   a price checkout won't honour.

     size chip       -> Shopify variant
     Abo    + 1 Dose -> Recharge "1 month" plan, qty 1
     Abo    + 3 Dosen-> Recharge "3 month" plan, qty 3
     Einmal + 1 Dose -> no plan, qty 1
     Einmal + 3 Dosen-> no plan, qty 3

   Plan data comes from the Liquid-emitted #jc-pdp-plans script: `product | json`
   does NOT reliably serialize selling_plan_allocations, which once left add-to-cart
   dead. Match plans by NAME, never by array order.
--------------------------------------------------------------------------- */
(function () {
  var root = document.querySelector(".jc-pdp");
  var sheet = document.getElementById("plSheet");
  if (!root || !sheet) return;

  function loadProduct() {
    var el = document.getElementById("jc-pdp-plans");
    if (el) {
      try {
        var d = JSON.parse(el.textContent);
        if (d && d.variants && d.variants.length) return d;
      } catch (e) { console.warn("[jc-pdp] jc-pdp-plans unparseable", e); }
    }
    var pe = document.getElementById("jc-pdp-product");
    if (pe) {
      try {
        var p = JSON.parse(pe.textContent);
        if (p && p.variants && p.variants.length) {
          return {
            handle: p.handle,
            variants: p.variants.map(function (v) {
              return {
                id: v.id, title: v.title, price: v.price, available: v.available,
                allocations: (v.selling_plan_allocations || []).map(function (a) {
                  return { plan_id: a.selling_plan.id, price: a.price, name: a.selling_plan.name };
                })
              };
            })
          };
        }
      } catch (e) { console.warn("[jc-pdp] product json unparseable", e); }
    }
    return null;
  }

  var product = loadProduct();
  if (!product) return; // no product assigned: the sheet stays a static mockup

  var cfg = {};
  var cfgEl = document.getElementById("jc-pdp-config");
  if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }
  var CURRENCY = cfg.currency || product.currency || "EUR";
  var LOCALE = cfg.locale || "de-DE";

  var nf = new Intl.NumberFormat(LOCALE, { style: "currency", currency: CURRENCY });
  function money(c) { return nf.format((c || 0) / 100); }
  function perDay(c, d) { return nf.format((c || 0) / 100 / d); }
  function pct(from, to) { return from > 0 ? Math.round((1 - to / from) * 100) : 0; }

  function currentVariant() {
    var b = sheet.querySelector(".pl-size.sel");
    var key = b ? (b.getAttribute("data-key") || "").toLowerCase().replace(/\s+/g, "") : "";
    for (var i = 0; i < product.variants.length; i++) {
      var t = (product.variants[i].title || "").toLowerCase().replace(/\s+/g, "");
      if (key && t.indexOf(key) !== -1) return product.variants[i];
    }
    return product.variants[0];
  }

  // Match on plan NAME, never array order — a wrong guess bills the wrong cadence.
  // Recharge names these differently depending on how they were created
  // ("1 month subscription with 30% discount", "Deliver every month", …), so match
  // the CADENCE, not a fixed string. Test the 3-month pattern first: "every 3 months"
  // also contains the word "month" and would otherwise be taken as the monthly plan.
  // Billing runs on 28-day cycles (1 Dose = 28 days, 3 Dosen = 84 days), so the
  // day-based alternatives are matched too — 28/84 for the current plans, 30/90
  // kept so a plan named the old way still resolves instead of silently failing.
  var RE_QUARTERLY = /(\b3\s*month|\b3\s*monat|\b(84|90)\s*(day|tag)|quarter|viertelj)/i;
  var RE_MONTHLY = /(month|monat|\b(28|30)\s*(day|tag))/i;

  // Volume break on ONE-TIME purchases. Mirrors the Shopify automatic discount
  // "2 kaufen, 1 gratis (Einmalkauf)" — BxGy, buy 2 of this product, get 1 at
  // 100% off, usesPerOrderLimit 1. The cart is the source of truth; this constant
  // only mirrors it so the sheet cannot quote a price checkout won't charge.
  //
  // This REPLACED the old "3er-Vorrat: 25 % Mengenrabatt" basic discount (now
  // deactivated). Both could not stay active: Shopify applies only one automatic
  // discount to a line, and the two are different money — 3 x 25,00 at 25% off is
  // 56,25, whereas one free tub is 50,00.
  //
  // Whole units are free, so unlike the percentage discount it replaced there is
  // no per-unit flooring to imitate — the arithmetic is exact at every tier.
  var FREE_EVERY = 3;

  function allocFor(v, months) {
    var a = (v && v.allocations) || [];
    var i, n;
    if (months === 3) {
      for (i = 0; i < a.length; i++) {
        n = a[i].name || "";
        if (RE_QUARTERLY.test(n)) return a[i];
      }
      return null;
    }
    for (i = 0; i < a.length; i++) {
      n = a[i].name || "";
      if (!RE_QUARTERLY.test(n) && RE_MONTHLY.test(n)) return a[i];
    }
    return null;
  }

  function isOneTime() { return sheet.getAttribute("data-mode") === "onetime"; }
  // Variant C: one-time only. Class is set by applyConfig('otponly'), so the copy
  // below can drop every Abo reference without any variant string leaking in here.
  function isOtpOnly() { return sheet.classList.contains("otp-only"); }

  // Cost of a card in a GIVEN mode (explicit, so the hint can compare modes safely).
  //
  // `was` is the strike-through reference and MUST be a price the customer could
  // otherwise have paid — otherwise the discount is invented. Two legitimate
  // sources, in order:
  //   1. the variant's compare_at_price (the merchant's own list price), if set
  //   2. the plain one-time price, when a subscription plan discounts it
  // If neither is above the price being charged, there is no discount and `was`
  // stays 0 — the UI then shows no badge and no strike-through.
  function figure(v, qty, oneTime) {
    // `months` only picks the cadence bucket (1 vs 3) for allocFor(); the real
    // billing cycle is 28 days, which is what the per-day figure must divide by
    // — a tub is 28 days of chews, so 30/90 understated it.
    var months = qty === 3 ? 3 : 1;
    var days = qty === 3 ? 84 : 28;
    var unit = v.price;
    var ca = v.compare_at || 0;

    if (oneTime) {
      // Shopify automatic discount "2 kaufen, 1 gratis (Einmalkauf)" makes every
      // third tub in a one-time line free. Shopify only applies it in the cart, so
      // mirror it here; otherwise the sheet quotes a price the cart won't charge.
      // qty 1 -> pay 1. qty 3 -> pay 2. Integer arithmetic, no rounding drift.
      var refOne = Math.max(unit, ca) * qty;
      var totalOne = unit * (qty - Math.floor(qty / FREE_EVERY));
      return {
        total: totalOne,
        was: refOne > totalOne ? refOne : 0,
        plan: null, qty: qty, days: days
      };
    }
    var a = allocFor(v, months);
    if (!a) {
      return {
        total: unit * qty,
        was: ca > unit ? ca * qty : 0,
        plan: null, qty: qty, days: days, missing: true
      };
    }
    var ref = Math.max(unit, ca);                 // best honest reference price
    return {
      total: a.price * qty,
      was: ref > a.price ? ref * qty : 0,
      plan: a.plan_id, qty: qty, days: days
    };
  }

  function selectedQty() {
    var sel = sheet.querySelector(".pl-plan.sel");
    return sel && sel.getAttribute("data-plan") === "q3" ? 3 : 1;
  }

  function render() {
    var v = currentVariant();
    var one = isOneTime();

    [].slice.call(sheet.querySelectorAll(".pl-plan")).forEach(function (card) {
      var qty = card.getAttribute("data-plan") === "q3" ? 3 : 1;
      var f = figure(v, qty, one);
      var save = f.was ? pct(f.was, f.total) : 0;

      card.querySelector(".pl-now").textContent = money(f.total);
      var was = card.querySelector(".pl-was");
      was.textContent = save > 0 ? money(f.was) : "";
      was.style.display = save > 0 ? "" : "none";

      // Variant C names the 3-pack "2 Dosen" so it reads as "2 Dosen + 1 GRATIS"
      // across the name and badge — the customer pays for two and the sub-line
      // ("3x Monatsvorrat") states what actually ships. Set in both directions, not
      // just for C, so the Liquid-authored "3 Dosen" is restored if the sheet is
      // ever reopened in another config. Same overwrite caveat as .pl-plan-sub below.
      var nameEl = card.querySelector(".pl-plan-name");
      if (nameEl) nameEl.textContent = qty === 3 ? (isOtpOnly() ? "2 Dosen" : "3 Dosen") : "1 Dose";

      // NOTE: this overwrites the .pl-plan-sub text authored in jc-pdp.liquid —
      // edit it HERE, not there, or the change silently never renders.
      var subLine = qty === 3 ? "3 Monate Vorrat" : "1x Monatsvorrat";
      // Variant C: the free tub is already stated by the "2 + 1 GRATIS" badge, so
      // the sub-line just mirrors the 1-Dose card's wording instead of repeating it.
      if (qty === 3 && isOtpOnly()) subLine = "3x Monatsvorrat";
      card.querySelector(".pl-plan-sub").textContent =
        subLine + " · " + perDay(f.total, f.days) + " pro Tag";

      // On variant C the 3-pack's selling point is the free tub, not an abstract
      // percentage — "1 DOSE GRATIS" is the same offer stated the way it was bought.
      var badge = card.querySelector(".pl-badge");
      if (qty === 3 && isOtpOnly()) { badge.textContent = "+ 1 GRATIS"; badge.hidden = false; }
      else if (save > 0) { badge.textContent = "SPARE " + save + "%"; badge.hidden = false; }
      else { badge.hidden = true; }

      // Variant C's 3-pack shows the percentage as a SECOND badge, because its
      // primary badge is spent on the free tub. Everywhere else the percentage is
      // already the primary badge, so this stays hidden rather than duplicating it.
      var badgeAlt = card.querySelector(".pl-badge-alt");
      if (badgeAlt) {
        if (qty === 3 && isOtpOnly() && save > 0) { badgeAlt.textContent = "SPARE " + save + "%"; badgeAlt.hidden = false; }
        else { badgeAlt.hidden = true; }
      }

      // "BESTER PREIS" only when 3 tubs really are cheaper per day than 1.
      var best = card.querySelector(".pl-best");
      if (qty === 3) {
        var f1 = figure(v, 1, one);
        best.hidden = !(f.total / f.days < f1.total / f1.days - 0.5);
      } else {
        best.hidden = true;
      }

      if (f.missing) card.setAttribute("data-plan-missing", "1");
      else card.removeAttribute("data-plan-missing");
    });

    var qty = selectedQty();
    var hint = document.getElementById("plHint");
    if (hint) {
      var subF = figure(v, qty, false);
      var oneF = figure(v, qty, true);
      var saves = oneF.total - subF.total;
      if (isOtpOnly()) {
        // Variant C sells no subscription, so there is no alternative mode to nudge
        // the customer toward. Hide the row rather than fill it with filler copy —
        // display is reset in the branches below so a config change can restore it.
        hint.style.display = "none";
      } else if (!one) {
        hint.style.display = "";
        // PetLab's line, in German. Mirrors "As a subscriber you are getting our
        // lowest price" — see the note below about what makes this true.
        hint.innerHTML = "Du bekommst unseren <b>besten Preis</b>.";
      } else {
        hint.style.display = "";
        // PetLab: "Switch to a subscription to save an extra £17.97".
        // The figure is computed, never hardcoded — printed only when the Recharge
        // plan genuinely undercuts the one-time price.
        hint.innerHTML = saves > 0
          ? "Wechsle zur Auto-Lieferung und spare <b>" + money(saves) + "</b>."
          : "Wechsle zur <b>Auto-Lieferung</b> – nie wieder nachbestellen, jederzeit kündbar.";
      }
    }

    var f = figure(v, qty, one);
    var txt = document.getElementById("plAtcTxt");
    if (txt) txt.textContent = "In den Warenkorb | " + money(f.total);

    // "Einmaliger Kauf {price}" link (variant B) — one-time price of a single tub.
    var otpP = document.getElementById("plOtpPrice");
    if (otpP) otpP.textContent = money(figure(v, 1, true).total);

    var offer = document.getElementById("plOfferLine");
    if (offer) {
      var f1s = figure(v, 1, false);
      var s1 = f1s.was ? pct(f1s.was, f1s.total) : 0;
      offer.textContent = s1 > 0
        ? s1 + "% RABATT + automatische Lieferung · jederzeit kündbar"
        : "Automatische Lieferung · GRATIS Versand · jederzeit kündbar";
    }

    var sp = document.getElementById("stickyPrice");
    var sd = document.getElementById("stickyDay");
    if (sp) sp.textContent = money(f.total);
    if (sd) sd.textContent = "· " + perDay(f.total, f.days) + "/Tag";
  }

  sheet.addEventListener("pl:change", render);
  render();

  var atc = document.getElementById("plAtc");
  if (!atc) return;

  // Refusing the add is correct (see the guard below), but doing it with only a
  // console.error read to the customer as a dead button: they hit "In den
  // Warenkorb" and nothing happened, with no way to tell what to do next.
  // role="alert" so it is announced, not just drawn.
  var atcErr = null;
  function showAtcError(msg) {
    if (!atcErr) {
      atcErr = document.createElement("p");
      atcErr.className = "pl-err";
      atcErr.setAttribute("role", "alert");
      atc.parentNode.insertBefore(atcErr, atc);
    }
    atcErr.textContent = msg;
    atcErr.hidden = false;
  }
  sheet.addEventListener("pl:change", function () { if (atcErr) atcErr.hidden = true; });

  atc.addEventListener("click", function () {
    var v = currentVariant();
    var qty = selectedQty();
    var one = isOneTime();
    var f = figure(v, qty, one);

    // Never silently add a chosen subscription as a full-price one-off.
    if (!one && !f.plan) {
      showAtcError("Dieses Abo ist gerade nicht verfügbar. Bitte wähle „Einmaliger Kauf“ oder versuche es in einem Moment noch einmal.");
      console.error("[jc-pdp] no Recharge plan for this selection; not adding.");
      try { if (window.posthog && posthog.capture) posthog.capture("add_to_cart_error", { reason: "no_selling_plan", variant_id: v.id, subscription: true, sheet_config: sheet.dataset.config || null, pdp_variant: window.JC_PDP_CHECKOUT_VARIANT || null }); } catch (_) {}
      return;
    }
    var item = { id: v.id, quantity: f.qty };
    if (f.plan) item.selling_plan = f.plan;

    atc.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("add.js " + r.status);
        sheet._plAdded = true; // so closing/leaving is not miscounted as an abandon
        // Conversion signal for PostHog experiments. Guarded so it's a no-op
        // when PostHog is disabled. Super-props (product_handle, template) are
        // auto-attached; PostHog flushes on unload via sendBeacon so the event
        // survives the immediate checkout redirect.
        try {
          if (window.posthog && posthog.capture) {
            var conv = { variant_id: v.id, quantity: f.qty, subscription: !one, selling_plan: f.plan || null, pdp_variant: window.JC_PDP_CHECKOUT_VARIANT || null, sheet_config: sheet.dataset.config || null, plan_switch_count: sheet._plSwitches || 0, value: (f.total || 0) / 100 };
            posthog.capture("add_to_cart", conv);
            posthog.capture("initiate_checkout", conv);
          }
        } catch (e) {}
        // Write the PDP A/B version onto the cart so it lands on the Shopify order.
        // Set HERE, at add time, on the page they actually bought from — never on
        // page load, so a redirected sub_first visitor can't be mislabelled.
        // Single-underscore key ("_PDP-Version") = hidden from the customer at
        // checkout / order status (per Shopify cart-attribute docs) but still stored
        // on the order and shown in the admin under "Additional details".
        // Anything not in this map is control, so an unknown/absent flag value can
        // never silently label an order as a variant it did not come from.
        var JC_VER = { sub_first: "Sub-first (B)", otp_only: "OTP-only (C)" };
        var jcVer = JC_VER[window.JC_PDP_CHECKOUT_VARIANT] || "Control (A)";
        var goCheckout = function () { window.location.href = "/checkout"; };
        fetch("/cart/update.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          // "PDP-Version": "" clears the legacy public key from any cart that
          // briefly received it before this fix (empty value removes an attribute).
          body: JSON.stringify({ attributes: { "_PDP-Version": jcVer, "PDP-Version": "", _ph_variant: window.JC_PDP_CHECKOUT_VARIANT || "" } })
        }).then(goCheckout, goCheckout);
      })
      .catch(function (e) {
        atc.disabled = false;
        try { if (window.posthog && posthog.capture) posthog.capture("add_to_cart_error", { reason: "request_failed", message: String((e && e.message) || e), variant_id: v.id, subscription: !one, sheet_config: sheet.dataset.config || null, pdp_variant: window.JC_PDP_CHECKOUT_VARIANT || null }); } catch (_) {}
        console.error("[jc-pdp] add to cart failed:", e);
        window.location.href = "/cart";
      });
  });
})();

/* Before/after videos: browsers often ignore the autoplay attribute for media
   below the fold. Play when scrolled into view (retrying silently if blocked)
   and pause off-screen to save battery. */
(function () {
  var vids = document.querySelectorAll(".qcard video");
  if (!vids.length) return;
  function tryPlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) tryPlay(e.target);
        else e.target.pause();
      });
    }, { threshold: 0.15 });
    vids.forEach(function (v) { v.muted = true; io.observe(v); });
  } else {
    vids.forEach(function (v) { v.muted = true; tryPlay(v); });
  }
})();
